import React from 'react'
import { Heading, Text } from '../../components/ui'
import { PermissionGuard } from '../../components/PermissionGuard'
import { modulesService } from '../../services/modules'
import ComissoesTab from './ComissoesTab'
import ExtratosContaTab from './ExtratosContaTab'

const MODULE_NAME = 'financeiro_P&L'

type ActiveTab = 'comissoes' | 'extratosConta'

const PeL: React.FC = () => {
  const [moduleInfo, setModuleInfo] = React.useState<{
    display_name: string
    description?: string | null
  } | null>(null)
  const [activeTab, setActiveTab] = React.useState<ActiveTab>('comissoes')

  React.useEffect(() => {
    const loadModule = async () => {
      const result = await modulesService.getByName(MODULE_NAME)
      if (result.success && result.data) {
        setModuleInfo({
          display_name: result.data.display_name ?? 'Financeiro P&L',
          description: result.data.description ?? null,
        })
      }
    }
    void loadModule()
  }, [])

  return (
    <div className="flex-1 flex flex-col overflow-x-hidden overflow-y-auto">
      <PermissionGuard moduleName={MODULE_NAME} permissionType="show">
          <div className="h-full flex flex-col">
            <div className="p-6 border-b border-gray-200 dark:border-gray-700">
              <Heading as="h1" size="3xl" className="text-gray-900 dark:text-white">
                {moduleInfo?.display_name ?? 'Financeiro P&L'}
              </Heading>
              {moduleInfo?.description && (
                <Text size="sm" color="muted" className="mt-1">
                  {moduleInfo.description}
                </Text>
              )}
            </div>

            <div className="px-6 pt-4 border-b border-gray-200 dark:border-gray-700">
              <div className="border-b border-gray-200 dark:border-gray-700">
                <nav className="-mb-px flex space-x-8">
                  <button
                    type="button"
                    onClick={() => setActiveTab('comissoes')}
                    className={`py-3 px-1 border-b-2 font-medium text-sm ${
                      activeTab === 'comissoes'
                        ? 'border-primary-600 text-primary-600 dark:text-primary-400'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-200'
                    }`}
                  >
                    Extrato Comissões Icatu
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab('extratosConta')}
                    className={`py-3 px-1 border-b-2 font-medium text-sm ${
                      activeTab === 'extratosConta'
                        ? 'border-primary-600 text-primary-600 dark:text-primary-400'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-200'
                    }`}
                  >
                    Extratos por conta
                  </button>
                </nav>
              </div>
            </div>

            {activeTab === 'comissoes' && <ComissoesTab />}
            {activeTab === 'extratosConta' && <ExtratosContaTab />}
          </div>
      </PermissionGuard>
    </div>
  )
}

export default PeL
